<template>
    <div >
      <DxPopup
        :visible="isVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        @hidden="onHiddenReport"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="Title"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
      >

      <div v-if="Extension !== '.pdf'">
         <div class="image-actions no-print mb-2">
           <!--<button @click="printImage"  class="no-print" :disabled="!imageLoaded">
                🖨 Imprimir
            </button>-->
            <span @click="printImage" class="no-print rounded-circle tableActionBTN tableBTNtext ikon med-print" ></span>
        </div>
        <div class="image-preview print-area">
            <img :key="reloadKey" :src="this.Url" @load="onImageLoaded" @error="onLoadError">
        </div>
        <div v-if="loadError" class="alert alert-danger mt-2">
          {{ $t('Msg.retrieveInfo') }}
          <button type="button" class="btn btn-sm btn-link" @click="retryLoad">{{ $t('Shared.Retry') }}</button>
        </div>
      </div>


      <iframe v-if="Extension === '.pdf'" :key="reloadKey" ref="imageFrame" id="iframe" :src="this.Url" width="100%" height="100%"  frameborder="0"></iframe>
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'

    export default Vue.extend({
        name: "DxPoPup",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          Title:String,
          isVisible: Boolean,
          Url:String,
          VisiblePrint:Boolean,
          closeWindow: Function,
          Extension:String
        },
        data() {
            return {
                   imageLoaded: false,
                   loadError: false,
                   reloadKey: 0
            }
        },
        methods: {
            onHiddenReport() {
              this.loadError = false;
              this.closeWindow()
            },
            onImageLoaded() {
                this.imageLoaded = true;
                this.loadError = false;
            },
            onLoadError() {
                this.loadError = true;
            },
            retryLoad() {
                this.loadError = false;
                this.imageLoaded = false;
                this.reloadKey++;
            },

            printImage() {
                if (!this.imageLoaded) {
                    return;
                }

                window.print();
            }
},

        mounted () {

        },
    })
</script>
<style>
  .dxrd-report-preview-holder {
      height: 94% !important;
  }

  .image-actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

@media print {

    body > * {
        visibility: hidden !important;
    }

    .print-area {
        visibility: visible !important;

        position: fixed !important;
        left: 0 !important;
        top: 0 !important;

        width: 100vw !important;
        height: 100vh !important;

        display: flex !important;
        justify-content: center !important;
        align-items: flex-start !important;

        overflow: visible !important;
    }

    .print-area img {
        visibility: visible !important;

        display: block !important;

        max-width: 100% !important;
        max-height: 100% !important;

        width: auto !important;
        height: auto !important;

        object-fit: contain !important;
    }

    .no-print {
        display: none !important;
    }
}
</style>
